import React from 'react';
import { Upload, message } from 'antd';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';

function ImageUpload(props) {
  const { loading, setLoading, selectedImage, setSelectedImage } = props;
  const token = useSelector((state) => get(state, 'auth.token'));

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error({
        content: 'You can only upload JPG/PNG file!',
        className: 'error-message',
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error({
        content: 'Image must smaller than 2MB!',
        className: 'error-message',
      });
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'error') {
      setLoading(false);
      return;
    }
    if (info.file.status === 'done') {
      setLoading(false);
      setSelectedImage(get(info, 'file.response.data.file_path'));
    }
  };

  return (
    <Upload
      name="file"
      listType="picture-card"
      className="avatar-uploader"
      headers={{ authorization: `Bearer ${token}` }}
      action={process.env.REACT_APP_IMAGE_URL}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      showUploadList={false}
      data={{ action: 'upload_file' }}
    >
      {selectedImage ? (
        <img src={selectedImage} alt="avatar" style={{ width: '100%' }} />
      ) : (
        <div>
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      )}
    </Upload>
  );
}

export default ImageUpload;
